import { footerColumns } from "@/mocks/gossipData";

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-5">
          <div className="md:col-span-2">
            <a href="#hero" className="flex items-center gap-2 whitespace-nowrap" aria-label="吃瓜大全 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50 text-lg">
                <i className="ri-emotion-happy-fill"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-bold text-foreground-950">吃瓜大全</span>
                <span className="mt-1 text-[10px] tracking-widest text-foreground-500">CHIGUA COLLECTION</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              聚合全网综艺、剧集、音乐与网络热议的精华帖与高赞内容，每日精选合集，帮你把时间花在值得看的瓜上。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-douban-line", "ri-bilibili-line", "ri-wechat-line", "ri-rss-line"].map((icon) => (
                <a
                  key={icon}
                  href="#hero"
                  aria-label="社交媒体链接"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300/70 text-foreground-600 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-colors"
                >
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-sm font-bold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#hero"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 吃瓜大全 · 仅供娱乐参考，图文版权归原作者所有
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
            <a href="#hero" className="hover:text-foreground-800">隐私政策</a>
            <a href="#hero" className="hover:text-foreground-800">免责声明</a>
            <a href="#faq" className="hover:text-foreground-800">帮助中心</a>
          </p>
        </div>
      </div>
    </footer>
  );
}